export function registerServiceWorker() {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;
  if (process.env.NODE_ENV !== 'production') return;

  window.addEventListener('load', () => {
    const url = `${process.env.PUBLIC_URL || ''}/sw.js`;
    navigator.serviceWorker.register(url).catch(() => {});
  });
}
